import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { StickyNote2 } from "@mui/icons-material";

const ItemSettings = () => {
  return (
    <Box
      sx={{
        // paddingTop: "90px",
        // paddingLeft: { xs: "8px", sm: "70px", lg: "80px" },
        // paddingRight: { xs: "8px", lg: "30px" },
        // paddingBottom: "8px",
        boxSizing: "content-box",
      }}
    >
      <Box
        sx={{
          minHeight: "550px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <Paper
          sx={{
            padding: "20px",
            borderRadius: "8px",
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "24px",
            }}
          >
            Item Settings
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: { sm: "flex-start" },
              flexWrap: { xs: "wrap", md: "nowrap" },
              flexDirection: { xs: "column", sm: "row" },
              marginBottom: "0px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ backgroundColor: "#c9c9c97a", borderRadius: "5px" }}>
                <Typography sx={{ fontWeight: "bold", m: 0.5 }}>
                  Default Item Settings
                </Typography>
              </Box>
              <FormControl sx={{ marginLeft: "20px", marginTop: "10px" }}>
                {/* <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel> */}
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="Goods"
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="Goods"
                    control={<Radio />}
                    label="Goods"
                  />
                  <FormControlLabel
                    value="Services"
                    control={<Radio />}
                    label="Services"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default ItemSettings;
